import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  id: "invoice",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22.781 30.417",
  style: {"fill":"currentColor"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "Groupe_262",
      "data-name": "Groupe 262",
      transform: "translate(0)"
    }, [
      _createElementVNode("path", {
        id: "Tracé_57",
        "data-name": "Tracé 57",
        d: "M86.158,0h-21a.891.891,0,0,0-.891.891V26.9a.891.891,0,0,0,.261.63l2.625,2.625a.891.891,0,0,0,1.26,0l1.995-1.995L72.4,30.156a.891.891,0,0,0,1.26,0l1.995-1.995,1.995,1.995a.891.891,0,0,0,1.26,0l1.995-1.995L82.9,30.156a.891.891,0,0,0,1.26,0l2.625-2.625a.891.891,0,0,0,.261-.63V.891A.891.891,0,0,0,86.158,0ZM74.767,6.693V5.664a.891.891,0,0,1,1.782,0V6.681h1.018a.891.891,0,1,1,0,1.782H75.022a1.018,1.018,0,0,0,0,2.036h1.273a2.8,2.8,0,0,1,.255,5.588v1.03a.891.891,0,0,1-1.782,0V16.1H73.749a.891.891,0,1,1,0-1.782h2.545a1.018,1.018,0,1,0,0-2.036H75.022a2.8,2.8,0,0,1-.255-5.588Zm5.664,16.087H70.886a.891.891,0,1,1,0-1.782h9.545a.891.891,0,1,1,0,1.782Z",
        transform: "translate(-64.268)"
      })
    ], -1)
  ])))
}